import {useMemo} from 'react';
import {useAppSelector} from 'store/hooks';
import {
  selectMetadataEditEditStatuses,
  selectMetadataEditStatuses,
} from '../metadataEditSlice';

export const useMetadataHasChanges = (): boolean => {
  const editStatuses = useAppSelector(selectMetadataEditEditStatuses);
  const statuses = useAppSelector(selectMetadataEditStatuses);

  return useMemo(
    () =>
      Object.keys(editStatuses).some(
        id => editStatuses[id].hasDataChanged || editStatuses[id].hasMoved,
      ) || Object.keys(statuses).some(id => statuses[id].changedStatus),
    [editStatuses, statuses],
  );
};
